<template>
<div>
   <TableActionHeader
        @filterChange="onFilterChange"
        @newItem="onNewItem"
        :newButton="$UIPrivilegeC('content/displaylayouts')">
    </TableActionHeader>

    <b-table
        ref="table"
        responsive="sm"
        striped
        hover
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
        :items="layoutList"
        :fields="fields"
        :small="true"
        :no-provider-paging="true"
        :no-provider-filtering="true"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        @filtered="onFiltered">
    </b-table>

    <TablePagination
        :total-rows="totalRows"
        :per-page="perPage"
        @pageChange="onPageChange">
    </TablePagination>

    </div>
</template>

<script>

import displayLayout from '@/store/displays/displayLayout'

export default {
   props: ['item'],
   data: function() {
        return {
            perPage: 15,
            currentPage: 1,
            filteredRows: 1,
            filteredLayouts: [],
            filter: "",
            /*fields: [
                { layoutName: this.$t('display_layouts.layout_name'), sortable: true },
                { usage: this.$t('display_layouts.usage'), sortable: true }
            ]*/

        }
    },
    watch: {
        item() {
            if (!this.item)
                this.$refs.table.clearSelected();
        }
    },
    computed: {
        layoutList() {
            return this.$store.state.displayLayout.layoutList;
        },
        fields() {
            return [
                { key: "layoutName", label: this.$t('display_layouts.layout_name'), sortable: true },
                { key: "usage", label: this.$t('display_layouts.usage'), sortable: true }
            ];
        },
        totalRows() {
            if (!this.filter) {
                return this.layoutList.length;
            }
            return this.filteredRows;
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.displayLayout) {
            this.$store.registerModule("displayLayout", displayLayout);
        }
        this.$store.dispatch('displayLayout/getLayoutList');
    },
    methods: {
        onNewItem() {
            this.$emit('newItem');
        },
        onFilterChange(filter) {
            this.filter = filter;
        },
        onSelectLayout(item) {
            this.$store.commit('displayLayout/changeSelectedLayout', item);
            this.$emit('selectItem', item);
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onRowSelected(items) {
            if (items[0])
                this.$emit('selectItem', items[0]);
        }
    }
}
</script>
